export const FONTSIZE = {
  content: '15px',
  heading: '42px',
  subheading: '20px',
};
